<div class="clamp-{{background}}-{{lines}} min-{{minLines}} {{type}} {{fixedHeight ? 'fixedHeight' : ''}}">
    <div class="content dont-break-out preserve-line-breaks">
        <ng-content></ng-content>
    </div>
</div>
